import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAnswer, fade } from '../quiz/quiz.component';
import { IQuestionListSetting } from 'src/app/shared/interfaces/question-list-setting';
import { ISingleLikertQuestion, ISingleMultiOptionQuestion, ISingleSortingQuestion, SingleMultipleCriteria } from 'src/app/shared/interfaces/index.interface';

@Component({
  selector: 'app-reduce-unknown-question',
  templateUrl: './reduce-unknown-question.component.html',
  styleUrls: ['./reduce-unknown-question.component.scss'],
  animations: [fade]
})
export class ReduceUnknownQuestionComponent {
  @Output() exitQuizEvent:EventEmitter<null> = new EventEmitter()
  @Output() timeOver:EventEmitter<null> = new EventEmitter()
  @Output() sendQuestionsDataEvent:EventEmitter<IAnswer[]> = new EventEmitter()
  @Input() unknownQuestionsAnswer:IAnswer[] = []
  @Input() questions:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[] = []
  @Input() config:any;

  time:number = 60;
  exited:boolean = false;
  showQuestions:boolean = false;
  interval:any
  questionListConfig:IQuestionListSetting = {
    // categoryName: null,
    firstQuestionNumber: 1,
    inEndOfPages: true,
    pageNumber: 1,
    isRealTime: true,
  }
  answers:IAnswer[] = []
  
  ngOnInit(): void {
    this.time = this.config.remainingTime;
  }

  setShowQuestions(){
    this.showQuestions = true;
    if(this.time)
      this.setTimer()
  }
  exitQuiz():void{
    this.exitQuizEvent.emit()
  }
  getTime():string{
    return `${this.time>=3600?`${Math.floor(this.time/3600)}:`:``}${Math.floor(this.time%3600/60)}:${Math.floor(this.time%60)}`
  }
  setTimer(){
    this.interval = setInterval(() => {
      this.time--;
      if(!this.time){
        this.timeOver.emit()
        clearInterval(this.interval)
      }
    }, 1000);
  }
  getAnswers():IAnswer[]{
    let answers:IAnswer[] = []
    this.unknownQuestionsAnswer.forEach(answer=>{
      answers.push({...answer, isUnknown: false})
    })
    return answers
  }
  updateData(answer:any){
    let index:number = this.answers.findIndex(a=>a.id==answer.id)
    if(index>-1)
      this.answers[index] = answer;
    else
      this.answers.push(answer);
  }
  getValidAnswers():IAnswer[]{
    return this.answers.filter(answer=>answer.valid==true)
  }
  progressBarWidth():number{
    return Math.floor(100*this.getValidAnswers().length/this.questions.length)
  }
  emitQuestions(){
    if(this.getValidAnswers().length>=(this.questions.length-this.config.validQuantity))
      this.sendQuestionsDataEvent.emit(this.answers.filter(answer=>answer.valid==true))
  }
}
